var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPendingOpacity = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.29391 3.58374C7.9384 2.48493 9.8718 1.89844 11.8496 1.89844C13.1628 1.89844 14.4632 2.1571 15.6764 2.65964C16.8897 3.16219 17.9921 3.89878 18.9207 4.82737C19.8493 5.75596 20.5859 6.85835 21.0884 8.0716C21.591 9.28486 21.8496 10.5852 21.8496 11.8984C21.8496 13.8763 21.2631 15.8097 20.1643 17.4541C19.0655 19.0986 17.5037 20.3804 15.6764 21.1372C13.8492 21.8941 11.8385 22.0921 9.89871 21.7063C7.9589 21.3204 6.17707 20.368 4.77855 18.9695C3.38002 17.571 2.42761 15.7892 2.04176 13.8493C1.65591 11.9095 1.85394 9.89886 2.61082 8.0716C3.36769 6.24434 4.64942 4.68256 6.29391 3.58374ZM16 10.9996H13V7.9996C13 7.73439 12.8946 7.48003 12.7071 7.2925C12.5196 7.10496 12.2652 6.9996 12 6.9996C11.7348 6.9996 11.4804 7.10496 11.2929 7.2925C11.1054 7.48003 11 7.73439 11 7.9996V11.9996C11 12.2648 11.1054 12.5192 11.2929 12.7067C11.4804 12.8942 11.7348 12.9996 12 12.9996H16C16.2652 12.9996 16.5196 12.8942 16.7071 12.7067C16.8946 12.5192 17 12.2648 17 11.9996C17 11.7344 16.8946 11.48 16.7071 11.2925C16.5196 11.105 16.2652 10.9996 16 10.9996Z",
    fill: "#FFD666"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPendingOpacity);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pending_opacity.70fc6ae5f0f29f04fd17a2d22d21a3ca.svg";